'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Google = function Google(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 24 24' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M19.826 10.415h-7.152v3.03h4.117c-.384 1.924-1.989 3.03-4.117 3.03-2.511 0-4.534-2.068-4.534-4.634 0-2.566 2.023-4.633 4.534-4.633A4.38 4.38 0 0 1 15.5 8.24l2.233-2.28C16.373 4.747 14.628 4 12.674 4 8.42 4 5 7.493 5 11.84c0 4.349 3.419 7.842 7.674 7.842 3.838 0 7.326-2.851 7.326-7.841 0-.463-.07-.962-.174-1.426z'
      })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Google;